<script setup lang="ts">
import {inject, ref} from "vue";
import Dialog from "primevue/dialog";
import Slider from "primevue/slider";
import Button from "primevue/button";
import Popover from "primevue/popover";
import {Link, usePage} from "@inertiajs/vue3";

defineProps({
    horizontal: Boolean,
})

const page = usePage();
const visible = ref(false);

const tokenPrice = 2.25;
const credits = ref(50);

const usersCredits = ref(page.props.user.credit_amount);
const creditsBought = ref(page.props.query['order-token']);

const success = ref(page.props.query['order-token'] && page.props.query['order-token'] !== '0');
</script>

<template>
    <div
        class="credits-counter  border relative"
        :class="usersCredits <= 5 ? 'bg-red-50 dark:bg-red-950 dark:border-red-800 hover:bg-red-100 dark:hover:bg-red-900 border-red-200' : 'bg-blue-50 dark:bg-blue-950 dark:border-blue-800 hover:bg-blue-100 dark:hover:bg-blue-900 border-blue-200'"
        @click="visible = !visible">
        <div v-if="horizontal" class="flex items-center gap-4 w-full group relative">
            <i class="pi pi-wallet !text-xl my-1"
            :class="usersCredits <= 5 ? 'text-red-500' : 'text-roori-blue'"></i>
            <div>
                <div>
                <span class="font-bold opacity-90">
                    {{usersCredits}}
                </span>
                    <span class="opacity-90 ml-1">{{ $t('common.credits') }}</span>
                </div>

                <span v-if="usersCredits <= 5" class="text-xs text-red-600 cursor-pointer">{{ $t('common.low_credits') }}</span>
            </div>
        </div>
        <template v-else>
            <div class="relative group flex flex-col items-center"  v-tooltip="usersCredits <= 5 ? $t('common.low_credits_tooltip') : null">
                <i :class="usersCredits <= 5 ? 'pi pi-exclamation-triangle text-red-500' : 'pi pi-wallet text-roori-blue'" class="!text-xl my-1"></i>
                <p class="font-bold opacity-90">
                    {{usersCredits}}
                </p>
                <p class="opacity-90">{{ $t('common.credits') }}</p>
                <div v-if="usersCredits <= 5" class="text-xs text-red-600 text-center mt-1 relative">
                    {{ $t('common.low_credits') }}
                </div>
            </div>
        </template>
        <!--<Popover ref="op">
            <div class="credit-info">
                <p>Kredity se používají pro odesílání SMS a používání AI funkcí.</p>
                <div class="credit-overview">
                    <h4>Se současnou výší kreditů dostanete</h4>
                    <div class="credit-item"><span>📩</span>4 SMS notifikace</div>
                    <div class="credit-item"><span>🤖</span>20 AI rezervací</div>
                </div>
                <Button label="Dobít kredity" icon="pi pi-plus" size="small" text  />
            </div>
        </Popover>-->

        <Dialog v-model:visible="visible" modal class="!bg-transparent overflow-hidden">
          <template #container>
              <div class="relative bg-top-bg select-none bg-white/90 dark:bg-black/40 backdrop-blur bg-cover">
                  <div class="fixed top-4 right-4 z-10">
                      <Button icon="pi pi-times" @click="visible = false" rounded severity="secondary"></Button>
                  </div>
                  <div class=" rounded-2xl md:w-[460px] p-8 flex flex-col items-center text-center shadow-xl ">
                      <!-- Ikona -->
                      <div class="bg-blue-100/40 dark:bg-blue-900/20 w-16 h-16 rounded-lg flex justify-center items-center mb-4">
                          <i class="pi pi-wallet !text-2xl text-blue-800"></i>
                      </div>

                      <!-- Nadpis -->
                      <h5 class="text-xl font-bold mb-2">{{ $t('common.credits_title') }}</h5>

                      <!-- Popis -->
                      <p class="text-sm opacity-80 mb-8">{{ $t('common.credits_description') }}</p>

                      <!-- Slider + výpočet ceny -->
                      <div class="w-full mb-10">
                          <div class="flex justify-between mb-4 text-lg font-bold dark:text-white">
                              <p class="flex items-center gap-1">
                                  <i class="pi pi-wallet"></i>
                                  {{ credits }}
                              </p>
                              <p>{{ Intl.NumberFormat('cs-CZ', { style: "currency", maximumFractionDigits: 2, currency: 'CZK' }).format(credits * tokenPrice) }}</p>
                          </div>
                          <Slider v-model="credits" :step="10" :min="50" :max="500"></Slider>
                          <div class="flex justify-between mt-2 text-sm ">
                              <span>50</span>
                              <span class="ml-1">250</span>
                              <span>500</span>
                          </div>
                      </div>

                      <div v-if="false" class="w-full">
                          <h4>Se vybranou výší kreditů dostanete</h4>
                          <div class="flex flex-col gap-2 w-full mb-4  rounded-xl">
                              <div class="flex justify-between items-center py-1 px-2 border-b dark:bg-gray-700 rounded shadow-sm transition-all duration-300 ease-out transform">
                                  <div class="flex items-center">
                                      <span class="mr-2">📩</span>
                                      <span class="font-medium text-sm dark:text-white">SMS notifikace</span>
                                  </div>
                                  <span class="font-medium text-sm dark:text-white transition-all duration-300 ease-out transform">{{ credits }}</span>
                              </div>
                              <div class="flex justify-between items-center py-1 px-2 bg-white dark:bg-gray-700 rounded shadow-sm transition-all duration-300 ease-out transform">
                                  <div class="flex items-center">
                                      <span class="mr-2">🤖</span>
                                      <span class="font-medium text-sm dark:text-white">AI rezervace</span>
                                  </div>
                                  <span class="font-medium text-sm dark:text-white transition-all duration-300 ease-out transform">{{ (credits*1.8).toFixed(0) }}</span>
                              </div>
                          </div>
                      </div>

                      <!-- Nová výše kreditů + tlačítko -->
                      <div class="w-full flex justify-between items-center bg-black/5 dark:bg-gray-800/50 rounded-xl p-4 font-semibold">
                          <div>
                              {{ $t('common.new_credits_level') }}
                              <span class="ml-2 bg-blue-400 text-white p-1 rounded">{{ credits + usersCredits }}</span>
                          </div>
                          <Link :href="`/app/purchase-credits/${credits}`">
                              <Button :label="$t('common.buy_credits')" class="bg-blue-600 hover:bg-blue-700 text-white rounded-lg px-4 py-2 font-semibold shadow-md dark:bg-blue-500 dark:hover:bg-blue-600" />
                          </Link>
                      </div>

                  </div>
              </div>
          </template>
        </Dialog>
        <Dialog v-model:visible="creditsBought" modal class="!bg-transparent overflow-hidden">
            <template #container>
                <div class="relative select-none  backdrop-blur bg-cover" :class="success ? 'bg-top-bg bg-white/90' : 'bg-red-200/80'">
                    <div class="fixed top-4 right-4 z-10">

                        <Button icon="pi pi-times" @click="creditsBought = false" rounded severity="secondary"></Button>
                    </div>
                    <div class=" rounded-2xl w-[460px] p-8 flex flex-col items-center text-center shadow-xl ">
                        <!-- Ikona -->
                        <div class="w-32 h-16 rounded-lg flex justify-center gap-4 items-center mb-4"
                             :class="{
                                'bg-red-100/40': true,
                            }">
                            <i class="pi pi-wallet !text-2xl"
                               :class="success ? 'text-blue-800' : 'text-red-800'"></i>
                            <span v-if="success" class="text-2xl font-bold text-blue-800"> {{usersCredits}}</span>
                            <span v-else class="text-2xl font-bold text-red-800">!!!</span>
                        </div>

                        <!-- Nadpis -->
                        <h5 class="text-xl font-bold mb-2">
                            <template v-if="success">{{ $t('common.credits_success') }}</template>
                            <template v-else>{{ $t('common.credits_error') }}</template>
                        </h5>

                        <!-- Popis -->
                        <p v-if="!success" class="text-sm opacity-80">
                            {{ $t('common.credits_contact') }} <a href="mailto:invoicing@maeum.one">invoicing@maeum.one</a>
                        </p>

                    </div>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<style scoped lang="scss">
.credits-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0.4rem 0.8rem;

    border-radius: 12px;
    backdrop-filter: blur(8px);
    color: var(--text-color, #fff);
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
        transform: translateY(-1px);
    }

    i {
        font-size: 1rem;
        opacity: 0.9;
    }

    span {
        font-weight: 500;
        opacity: 0.9;
    }

    .p-button {
        margin-left: 0.5rem;
        font-size: 0.8rem;
    }
}

.credit-info {
    background: #fff;
    border-radius: 16px;
    color: #1c1c1e;
    font-size: 0.9rem;
    line-height: 1.5;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.credit-overview {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    background: #f5f5f7;
    border-radius: 12px;

    h4 {
        margin: 0;
        font-weight: 600;
        font-size: 0.95rem;
        color: #1c1c1e;
    }

    .credit-item {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.9rem;
        color: #3c3c43;
    }
}

.recharge-button {
    align-self: flex-start;
    font-size: 0.85rem;
    color: #007aff;
    background: transparent;
    padding: 0;
    height: auto;
    display: flex;
    align-items: center;
    gap: 0.25rem;

    &:hover, &:focus {
        background: rgba(0, 122, 255, 0.1);
    }
}

.tooltip-message {
    font-size: 0.75rem;
    color: #1a202c;
    background-color: #f9fafb;
    border-radius: 0.375rem;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    padding: 0.25rem 0.5rem;
    line-height: 1.2;
    max-width: 280px;
    z-index: 50;
}

@keyframes fade-in {
    from {
        opacity: 0;
        transform: translateY(4px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
